// This is being used for the generic modal in the application
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Add escape key listener
    document.addEventListener('keydown', this.handleKeyDown.bind(this))
    
    // Add click outside listener
    this.bindClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.bindClickOutside)
    
    // Prevent body scrolling when modal is open
    document.body.style.overflow = 'hidden'
  }
  
  disconnect() {
    // Remove escape key listener
    document.removeEventListener('keydown', this.handleKeyDown.bind(this))
    
    // Remove click outside listener
    document.removeEventListener('click', this.bindClickOutside)
    
    // Restore body scrolling
    document.body.style.overflow = ''
  }
  
  close() {
    // Remove the modal element
    this.element.remove()
  }
  
  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
  
  handleClickOutside(event) {
    // Find the modal content
    const modalContent = this.element.querySelector('.bg-white')
    
    // If click is outside modal content but inside modal container
    if (modalContent && !modalContent.contains(event.target) && this.element.contains(event.target)) {
      this.close()
    }
  }
} 